import * as React from "react";

import {
	withStyles,
	WithStyles,
	createStyles,
	Theme,
	useTheme,
} from "@material-ui/core/styles";
import { Grid, Paper, PaperProps, Typography, Input } from "@material-ui/core";
import {
	CardCvcElement,
	CardExpiryElement,
	CardNumberElement,
} from "@stripe/react-stripe-js";
import Utility from "../../domain/classes/Utility";
import { usePaymentManager } from "../../contexts/PaymentManager.Context";

export const styles = (theme: Theme) =>
	createStyles({
		root: {
			padding: theme.spacing(1),
			height: theme.spacing(22),
			maxWidth: theme.spacing(38),
			margin: "auto",
			border: `1px solid ${theme.palette.primary.main}`,
			marginTop: theme.spacing(4),
		},
		cardElementsContainer: {
			display: "flex",
			height: "100%",
		},
		cardElement: { width: "100%" },
		elementContainer: {
			display: "flex",
			justifyContent: "center",
			flexFlow: "column",
		},
	});

export interface CreditCardFrontProps extends PaperProps {}

const CreditCardFront: React.FC<
	CreditCardFrontProps & WithStyles<typeof styles>
> = ({ classes, className, ...paperProps }) => {
	const theme = useTheme();

	// Contexts
	const { handleCardHolderChange } = usePaymentManager();

	// handler
	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		handleCardHolderChange(event.target.value as string);
	};

	return (
		<Paper className={classes.root} {...paperProps}>
			<Grid
				container
				spacing={1}
				className={classes.cardElementsContainer}
			>
				<Grid item xs={12} className={classes.elementContainer}>
					<Typography variant="caption">Cardholder's name</Typography>
					<Input
						disableUnderline
						placeholder="Name on card"
						onChange={handleInputChange}
						required={process.env.NODE_ENV !== "development"}
					/>
				</Grid>

				<Grid item xs={12} className={classes.elementContainer}>
					<Typography variant="caption">Card number</Typography>
					<CardNumberElement
						className={classes.cardElement}
						options={{
							showIcon: true,
							style: {
								base: {
									fontSize: "18px",
									color: theme.palette.primary.main,
								},
							},
						}}
					/>
				</Grid>
				<Grid item xs={6} className={classes.elementContainer}>
					<Typography variant="caption">Expiry</Typography>
					<CardExpiryElement
						className={classes.cardElement}
						options={{
							style: {
								base: {
									fontSize: "18px",
									color: theme.palette.primary.main,
								},
							},
						}}
					/>
				</Grid>
				<Grid item xs={6} className={classes.elementContainer}>
					<Typography variant="caption">CVC</Typography>
					<CardCvcElement
						className={classes.cardElement}
						options={{
							style: {
								base: {
									fontSize: "18px",
									color: theme.palette.primary.main,
								},
							},
						}}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName("CreditCardFront"),
})(CreditCardFront);
